module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-04.c526e0d6.png";